import React from "react";
import { useI18n } from "../i18n/I18nProvider";
import { ArrowRight, Mountain, Zap } from "lucide-react";

const HERO_IMG = "https://images.unsplash.com/photo-1629014568959-f8260cbe6cd8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxkb2xvbWl0ZXMlMjBtb3VudGFpbiUyMHJvYWR8ZW58MHx8fHwxNzc4NzYyNzU5fDA&ixlib=rb-4.1.0&q=85";

export default function Hero({ onBook }) {
  const { t } = useI18n();
  return (
    <section className="relative min-h-screen overflow-hidden grain-overlay" data-testid="hero-section">
      <div className="absolute inset-0">
        <img src={HERO_IMG} alt="Dolomites mountain road" className="w-full h-full object-cover animate-fade-in" style={{ filter: "saturate(1.05) contrast(1.05)" }} />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-black/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-black/30" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 min-h-screen flex flex-col justify-between">
        <div className="pt-12">
          <div className="flex items-center gap-3 mb-4 animate-fade-up flex-wrap">
            <Mountain className="w-4 h-4 text-scooter-yellow" />
            <span className="text-[11px] tracking-[0.35em] uppercase font-bold text-scooter-yellow">{t.hero.kicker}</span>
            <span className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.3em] uppercase font-bold px-2.5 py-1 border border-scooter-yellow/60 bg-scooter-yellow/10 text-scooter-yellow" data-testid="hero-electric-chip">
              <Zap className="w-3 h-3 fill-scooter-yellow" />
              {t.hero.electric_chip || "100% Elettrico"}
            </span>
          </div>
          <h1 className="font-heading font-black text-white tracking-tighter leading-[0.92] animate-fade-up mt-4" style={{ animationDelay: "0.1s" }}>
            <span className="block text-5xl sm:text-7xl lg:text-8xl">{t.hero.title_pre}</span>
            <span className="block text-5xl sm:text-7xl lg:text-8xl">
              <span className="text-white">{t.hero.title_mid} </span>
              <span className="text-scooter-yellow italic">{t.hero.title_accent}</span>
              <span className="text-white"> {t.hero.title_end}</span>
            </span>
          </h1>
          <p className="mt-8 max-w-xl text-zinc-300 text-base sm:text-lg leading-relaxed animate-fade-up" style={{ animationDelay: "0.3s" }}>{t.hero.sub}</p>
          <div className="mt-10 flex flex-col sm:flex-row flex-wrap gap-4 animate-fade-up" style={{ animationDelay: "0.5s" }}>
            <button onClick={onBook} className="group inline-flex items-center justify-center gap-3 bg-scooter-yellow text-black font-bold text-sm tracking-[0.2em] uppercase px-8 h-14 hover:bg-scooter-yellow-hover transition-all" data-testid="hero-book-btn">
              {t.hero.cta}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <a href="#fleet" className="group inline-flex items-center justify-center gap-3 border-2 border-scooter-yellow bg-scooter-yellow/10 text-scooter-yellow font-bold text-sm tracking-[0.2em] uppercase px-8 h-14 hover:bg-scooter-yellow/20 transition-all" data-testid="hero-explore-btn">
              {t.hero.cta2}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>

        <div className="mt-16 hidden lg:grid grid-cols-4 gap-6 animate-fade-up" style={{ animationDelay: "0.7s" }}>
          {[
            { v: "120", u: "km/h max" },
            { v: "100", u: "km range" },
            { v: "ABS", u: "+ TCS" },
            { v: "9.9", u: "kW power" },
          ].map((s, i) => (
            <div key={s.u} className="border-l-2 border-scooter-yellow pl-4">
              <div className="text-3xl font-heading font-black text-white">{s.v}</div>
              <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-zinc-500 mt-1">{s.u}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
